import { useEffect } from 'react';
import { auth } from '../firebase';
import { signOut } from 'firebase/auth';


const useAutoLogout = (timeout = 45 * 60 * 1000) => {

    useEffect(() => {
        const timer = setTimeout(() => {
            signOut(auth)
                .then(() => {
                    console.log('Déconnecté automatiquement après 45 minutes');
                })
                .catch((error) => {
                    console.error('Erreur lors de la déconnexion :', error);
                });
        }, timeout);

        return () => clearTimeout(timer);
    }, [timeout]);
};

export default useAutoLogout;